/* eslint-disable max-len */

export const port = process.env.PORT || 3000;
export const host = process.env.API_HOST || 'http://localhost:8000';

export const analytics = {
  // https://analytics.google.com/
  google: {
    trackingId: process.env.GOOGLE_TRACKING_ID, // UA-XXXXX-X
  },
};

console.log('Host is', host);



// WEBPACK FOOTER //
// src/config.js